export default {
    'contact.companyInfo.contactUs':'contact us',
    'contact.companyInfo.h2.01':'Shenzhen Headquarters Office',
    'contact.companyInfo.p.01':'Dalang Industrial Park, Longhua District, Shenzhen City, Guangdong Province',
    'contact.companyInfo.h2.02':'Phone',
    'contact.companyInfo.p.02':'Phone: +86 18688782252, whatsApp,skype +86 18576744474',

    'contact.companyInfo.cardServer.h1':'WORKING HOURS',
    'contact.companyInfo.cardServer.p':'It is our mission to provide you with top class service.',
    'contact.companyInfo.cardServer.div1.span1':'Monday to Saturday',
    'contact.companyInfo.cardServer.div1.span2':'8:00 ~ 22:00',
    'contact.companyInfo.cardServer.div2.span1':'Customer Care',
    'contact.companyInfo.cardServer.div2.span2':'7 * 24h',
    'contact.companyInfo.cardServer.div3.span1':'Logistics services',
    'contact.companyInfo.cardServer.div3.span2':'7 * 24h',


    'contact.form.h1':'Message consultation',
    'contact.form.label.name':'Name',
    'contact.form.label.name.placeholder':'Please fill in your name',
    'contact.form.label.type':'Type of enquiry',
    'contact.form.label.type.placeholder':'Please select type of enquiry',
    'contact.form.label.type.option.01':'Product Enquiry / Quotation',
    'contact.form.label.type.option.02':'Logistic Quotation',
    'contact.form.label.type.option.03':'Logistic Enquiry',
    'contact.form.label.type.option.04':'Customer Service',
    'contact.form.label.type.option.other':'Others',
    'contact.form.label.email':'Email',
    'contact.form.label.email.placeholder':'Please fill in your email',
    'contact.form.label.phone':'Phone',
    'contact.form.label.phone.placeholder':'Please fill in your phone number',
    'contact.form.label.content':'Message.',
    'contact.form.label.content.placeholder':'Please leave your message here',
    'content.form.submit':'Submit'
}